import makeStyles from "@mui/styles/makeStyles";
import {
  FormControlLabel,
  Typography,
  Box,
  Button,
  Grid,
  Checkbox,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import {
  useStyles,
  AccordionSummary,
  AccordionDetails,
} from "../../shared/styles/common";
import SavedCardResult from "./savedCardResult";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";
import { registerLocale } from "react-datepicker";
import { authService } from "services/authService";
import de from "date-fns/locale/de";
import es from "date-fns/locale/es";
import fr from "date-fns/locale/fr";
import dompurify from "dompurify";
import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "helpers/axiosInstance";
import { appInsights } from "helpers/appInsights";
import { useDispatch,useSelector } from "react-redux";
import {
  ManualCardActivityResult,
  ManualCardPaymentStoreStartActivity,
  ManualCardPaymentStoreStartActivityInitialState,
  MyPaymentMethodType,
} from "../../Reservation/steps/Payment/paymentType";
import { broadcastAnnouncement } from "components/store/actions/shared/announcementActions";
import {
  clearAlertMessage,
  showErrorAlertMessage,
  showSuccessAlertMessage,
} from "components/store/actions/shared/alertActions";
import { getApiOrigin } from "helpers/history";
import { SeverityLevel } from "@microsoft/applicationinsights-common";
import { useNavigate } from "react-router-dom";
import { AppState } from "components/store/reducers/rootReducer";


const useStyles1 = makeStyles({
  root: {
    "& .MuiFormHelperText-root": {
      color: "#DF0000",
      fontSize: 12,
      marginLeft: "15px",
    },
    "& ::placeholder": {
      fontStyle: "italic",
      color: "#000",
      opacity: 0.95,
      whiteSpace: "pre-wrap",
      "@media (max-width:330px)": {
        fontSize: "0.6rem",
      },
    },
    "& .MuiTypography-h1": {
      color: "red",
      fontSize: 14,
      marginLeft: "15px",
    },
  },
  inputRoot: {
    fontSize: 30,
  },
  labelRoot: {
    fontSize: 30,
    color: "red",
    "&$labelFocused": {
      color: "purple",
    },
  },
  labelText: {
    color: "#000",
    fontFamily: "Arial, Roboto, Segoe UI",
    fontSize: "0.80rem",
    fontWeight: "bold",
    verticalAlign: "middle",
  },
  errorWarning: {
    color: "#DF0000",
    fontSize: 12,
    marginLeft: "15px",
  },
  backdrop: {
    zIndex: 99999,
    color: "#fff",
  },
  labelFocused: {},
});

const MyPaymentMethod: React.FC<MyPaymentMethodType> = (props) => {
  const [isChecked, setIsChecked] = useState(false);
  const user = authService.getUserObject();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes1 = useStyles1();
  const classes = useStyles();

  const theme = useTheme();
  const IsDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  const [loading, setLoading] = React.useState(true);
  const [showIframe, setShowIframe] = React.useState(false);
  const [frameHeight, setFrameHeight] = React.useState(600);
  const [showResult, setShowResult] = React.useState(false);
  const [iframeLoaded, setIframeLoaded] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [canContinue, setCanContinue] = React.useState(false);
  const [focusedButton, setFocusedButton] = useState<"yes" | "no" | null>(null);
  const btnNoRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = React.useState(false);
  const[updateCard,setUpdateCard]= React.useState(false);
  const apiOrigin = getApiOrigin();
  const history = useNavigate();
  const { companyInfo } = useSelector((state: AppState) => state.companyInfo);
  const [paymentContext, setPaymentContext] =
    useState<ManualCardPaymentStoreStartActivity>(
      ManualCardPaymentStoreStartActivityInitialState
    );
  const [paymentResult, setPaymentResult] =
    useState<ManualCardActivityResult | null>(null);

  const sanitizedHtml = dompurify.sanitize(
    t("PMSecureConnection", { usrlocale: authService.getUserLocale() }),
    { ADD_ATTR: ["target"] }
  );
  registerLocale("de", de);
  registerLocale("es", es);
  registerLocale("fr", fr);

  const handleCheckBoxChange = (event) => {
    dispatch(clearAlertMessage());
    setIsChecked(event.target.checked);
  };

  const handleButtonClick = async () => {
    dispatch(clearAlertMessage());
    if (isChecked) {
      const getMcbpsFrame = async () => {
        await getMcbpsFrameData();
      };
      getMcbpsFrame();
    }
  };

  useEffect(() => {
    console.log("Payment Context Changed: ", paymentContext);
    window.addEventListener("message", handler);

    // clean up
    return () => window.removeEventListener("message", handler);
  }, [paymentContext]);

  useEffect(() => {
    setLoading(true);
    getPaymentResult();
    console.log("Payment Result: ", paymentResult);
  }, []);

  const handleNavigation = (nav, state = {}) => {
    history(nav, { state });
  };

  const handler = async (event) => {
    if (event.data.toString().includes("new_height")) {
      let height = event.data.toString().split(":")[1];
      setFrameHeight(height);
      return;
    }
    if (event.origin !== apiOrigin) return;
    let data = JSON.parse(event.data.toString());
    console.log("Message Data:", data);
    console.log("AcitivityUrn: ", paymentContext?.activityUrn);
    if (data.success === "success") {
      await createPaymentStore(data.success, data.sessionId);
    } else {
      console.log("Error in Iframe confirmation:");
      dispatch(showErrorAlertMessage(t("UnexpectedError")));
      dispatch(broadcastAnnouncement(t("UnexpectedError")));
      setShowIframe(false);
      setCanContinue(false);
      setPaymentResult(null);
      setShowResult(true);
    }
  };
  const ConvertToPaymentResult = (dto): ManualCardActivityResult | null => {
    if (dto) {
      return {
        data: {
          cardDetails: {
            nameProvided: dto.cardBrand,
            maskedCardNumber: dto.cardLastDigits,
            expiration: {
              lastValidMonth: dto.expiryMonth.toString(),
              year: dto.expiryYear.toString(),
            },
          },
          cardAttributes: {
            cardBrand: dto.cardBrand,
            cardIssuer: "",
          },
        },
        errors: "",
        success: true,
      };
    }
    return null;
  };

  const getPaymentResult = async () => {
    await axiosInstance
      .get("paymentstore/details")
      .then(async (res) => {
        console.log("Existing Payment Card Details: ", res.data);
        if (res.data) {
          let resultData = ConvertToPaymentResult(res.data);
          setPaymentResult(resultData);
          setShowIframe(false);
          setShowResult(true);
        } else {
          setShowIframe(false);
          setShowResult(false);
        }
      })
      .catch((err) => {
        console.log("Error in getting usercount");
      });
    setLoading(false);
  };


  const handleUpdateCard = async () => {
    dispatch(clearAlertMessage());
    setUpdateCard(true);
    setLoading(true);
    setShowResult(false);
    setCanContinue(false);

    const model = {
      Locale: user.isoLanguageCode,
      Title: user.title,
      FirstName: user.firstName,
      LastName: user.lastName,
      Email: user.emailAddress,
      PhoneNumber: "+44123456789",
    };

    await axiosInstance
      .post("/paymentstore/updatepaymentstoreactivity", model)
      .then((res) => {
        console.log("Payment Frame Data: ", res.data);
        if (res.data.success) {
          setPaymentContext(res.data);
          setShowIframe(true);
          setIframeLoaded(true);
        } else {
          console.log("Validation Error", res.data.errors);
          let errorlist: string[] = [];
          if (Object.keys(res.data.errors).length > 0) {
            for (const [key, value] of Object.entries(res.data.errors)) {
              if (
                key === "unexpectedError" &&
                Object.keys(res.data.errors).length > 1
              )
                // remove the exception error if there are more than 1 errors in the list
                continue;
              else errorlist.push(value as string);
            }
            setShowResult(true);
            dispatch(showErrorAlertMessage(errorlist));
            dispatch(broadcastAnnouncement(errorlist.join(". ")));
          } else {
            window.scrollTo(0, 0);
            setShowResult(true);
            dispatch(showErrorAlertMessage(t("UnexpectedError")));
            dispatch(broadcastAnnouncement(t("UnexpectedError")));
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        window.scrollTo(0, 0);
        setShowResult(true);
        console.log("Error in getting usercount");
        dispatch(showErrorAlertMessage(t("UnexpectedError")));
        dispatch(broadcastAnnouncement(t("UnexpectedError")));
        setLoading(false);
      });
  };

  const getMcbpsFrameData = async () => {
    setLoading(true);
    setShowResult(false);
    setCanContinue(false);

    const model = {
      Locale: user.isoLanguageCode,
      Title: user.title,
      FirstName: user.firstName,
      LastName: user.lastName,
      Email: user.emailAddress,
      PhoneNumber: "+44123456789",
    };

    await axiosInstance
      .post("/paymentstore/startpaymentstoreactivity", model)
      .then((res) => {
        console.log("Payment Frame Data: ", res.data);
        if (res.data.success) {
          setPaymentContext(res.data);
          setShowIframe(true);
          setIframeLoaded(true);
        } else {
          console.log("Validation Error", res.data.errors);
          setShowIframe(false);
          setIsChecked(false);
          let errorlist: string[] = [];
          if (Object.keys(res.data.errors).length > 0) {
            for (const [key, value] of Object.entries(res.data.errors)) {
              if (
                key === "unexpectedError" &&
                Object.keys(res.data.errors).length > 1
              )
                // remove the exception error if there are more than 1 errors in the list
                continue;
              else errorlist.push(value as string);
            }
            dispatch(showErrorAlertMessage(errorlist));
            dispatch(broadcastAnnouncement(errorlist.join(". ")));
          } else {
            window.scrollTo(0, 0);
            dispatch(showErrorAlertMessage(t("UnexpectedError")));
            dispatch(broadcastAnnouncement(t("UnexpectedError")));
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        setShowIframe(false);
        setIsChecked(false);
        console.log("Error in getting usercount");
        window.scrollTo(0, 0);
        dispatch(showErrorAlertMessage(t("UnexpectedError")));
        dispatch(broadcastAnnouncement(t("UnexpectedError")));
        setLoading(false);
      });
  };

  const createPaymentStore = async (status: string, sessionId?: string) => {
    let model = {
      status: status,
      activityUrn: paymentContext?.activityUrn,
      contextId: paymentContext.contextId,
      sessionId: sessionId,
    };
    setLoading(true);
    setErrorMessage("");
    console.log("update card",updateCard);
    console.log("Sending request to create payment store activity: ", model);
    await axiosInstance
      .post("/paymentstore/createpaymentstoreactivity", model)
      .then(async (res) => {
        if (res.data.success) {
          await props?.onCardUpdated?.(); 
          console.log("Create Payment Store Activity success Data: ", res.data);
          setPaymentResult(res.data);
          setShowResult(true);
          setShowIframe(false);
        } else if(!updateCard){
          window.scrollTo(0, 0);
          dispatch(showErrorAlertMessage(t("UnexpectedError")));
          dispatch(broadcastAnnouncement(t("UnexpectedError")));
          setIframeLoaded(false);
          setIsChecked(false);
        }
        else{
          window.scrollTo(0, 0);
          setShowResult(true);
          dispatch(showErrorAlertMessage(t("UnexpectedError")));
          dispatch(broadcastAnnouncement(t("UnexpectedError")));
        }   
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error in Create Payment Store Activity:", err);
        window.scrollTo(0, 0);
        dispatch(showErrorAlertMessage(t("UnexpectedError")));
        dispatch(broadcastAnnouncement(t("UnexpectedError")));
        if(!updateCard){
          setPaymentResult(null);
          setShowResult(false);
          setIframeLoaded(false);
        }
        else{
          setShowResult(true);
        }
        setIsChecked(false);
        setShowIframe(false);
        setLoading(false);
        setCanContinue(false);
      });
  };

  const onEnterResetButtonDialog = () => {
    if (null !== btnNoRef.current) {
      btnNoRef.current.focus();
    }
  };

  const handleDeleteCardDialogClose = () => {
    setOpen(false);
  };

  const handleDeleteClick = async () => {
    dispatch(clearAlertMessage());
    setOpen(false);
    setUpdateCard(false);
    setLoading(true);
    await axiosInstance
      .post("/paymentstore/deletesavedcard")
      .then(async(response) => {
        if (response.data.success) {
         
          dispatch(showSuccessAlertMessage(t("RemoveSavedCardSuccess")));
          await props?.onCardDeleted?.();
          if(!companyInfo?.isCreditCardEnabled && !companyInfo?.isCCProfileManagementActivated) {
            handleNavigation("/admin/user/myprofile", {
              state: {
                showSuccessMessage: true,
                message: t("RemoveSavedCardSuccess"),
              },
            });
          }
          else{
          setIsChecked(false);
          setIframeLoaded(false);
          setShowResult(false);
          setLoading(false);
          appInsights.trackEvent({
            name: "Saved Card Deleted",
            properties: { transactionprofileId: response.data.txnProfileUid },
          });
          }
        } else {
          dispatch(showErrorAlertMessage(t("UnexpectedError")));
          dispatch(broadcastAnnouncement(t("UnexpectedError")));
        }
      })
      .catch((error) => {
        console.error("There is an error", error);
        dispatch(showErrorAlertMessage(t("UnexpectedError")));
        dispatch(broadcastAnnouncement(t("UnexpectedError")));
        appInsights.trackException({
          id: "Delete Saved Card",
          exception: error,
          severityLevel: SeverityLevel.Error,
        });
        setLoading(false);
      });
  };

  const handleDeleteSavedCardDialogOpen = () => {
    setOpen(true);
  };

  return (
    <Box
      id="savedPaymentMethod"
      boxShadow={3}
      p={3}
      bgcolor="background.paper"
      padding="2rem"
      className={classes1.root}
    >
      <Dialog
        aria-labelledby="deleteCard-Dialog-title"
        open={open}
        role="dialog"
        TransitionProps={{
          onEnter: onEnterResetButtonDialog,
        }}
      >
        <DialogContent id="deleteCard-Dialog-title">
          {t("RemoveCard")}
          <Divider
            style={{
              marginTop: 20,
              backgroundColor: "black",
              height: "0.8px",
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant={focusedButton === "yes" ? "contained" : "outlined"}
            type="submit"
            id="okDialogButton"
            onFocus={() => setFocusedButton("yes")}
            onClick={() => {
              handleDeleteClick();
            }}
            style={{ textTransform: "none" }}
          >
            {t("Yes")}
          </Button>
          <Button
            classes={{ outlinedPrimary: classes1.root }}
            color="primary"
            variant={focusedButton === "no" ? "contained" : "outlined"}
            type="button"
            ref={btnNoRef}
            id="cancelDialogButton"
            onFocus={() => setFocusedButton("no")}
            onClick={() => {
              handleDeleteCardDialogClose();
            }}
            style={{ marginLeft: "0.5em", textTransform: "none" }}
          >
            {t("No")}
          </Button>
        </DialogActions>
      </Dialog>
      <Typography
        id="savedPaymentMethodHeader"
        component="h2"
        sx={{
          fontWeight: "bold",
          fontSize: "large",
        }}
      >
        {t("SavedPaymentMethod")}
      </Typography>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress />
      </Backdrop>
      <Grid>
        {!iframeLoaded && !showResult && !loading && (
          <FormControlLabel
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginTop: "2.5em",
            }}
            id="checkboxContainer"
            control={
              <Checkbox
                id="consent-checkbox"
                checked={isChecked}
                onChange={handleCheckBoxChange}
                sx={{
                  transform: "scale(1.1)",
                  padding: "0rem",
                  marginLeft: "1.5rem",
                }}
              />
            }
            label={
              <Typography
                id="consentMessage"
                sx={{
                  marginTop: 0,
                  marginLeft: ".5%",
                  whiteSpace: "normal",
                  lineHeight: 1.5,
                }}
              >
                {t("Consent")}
              </Typography>
            }
            htmlFor="consent-checkbox"
          />
        )}
      </Grid>

      <Grid
        id="privacyMessage"
        item
        xs={12}
        style={{ textAlign: "center", marginTop: "1rem" }}
      >
        <div
          id="PMSecureConnection"
          dangerouslySetInnerHTML={{
            __html: sanitizedHtml,
          }}
        />
      </Grid>

      {!iframeLoaded && !showResult && !loading && (
        <Grid
          id="savedPMContainer"
          boxShadow={3}
          p={3}
          bgcolor="background.paper"
          sx={{ maxWidth: "32rem" }}
          style={{
            textAlign: "left",
            marginLeft: IsDesktop ? "30%" : "0%",
            width: IsDesktop ? "40%" : "100%",
            verticalAlign: "middle",
            justifyContent: "center",
          }}
        >
          <Typography id="savedPMSubHeader" style={{ fontWeight: "bold" }}>
            {t("SavedPaymentMethod")}
          </Typography>

          <Box sx={{ borderBottom: "3px solid grey", marginTop: "1rem" }} />
          {!iframeLoaded && (
            <Typography
              id="noPMSavedMessage"
              sx={{ margin: "1rem 0", fontStyle: "italic" }}
            >
              {t("NoPaymentMethodSaved")}
            </Typography>
          )}

          <Button
            color="primary"
            id="btnSubmit"
            variant="contained"
            disabled={!isChecked}
            type="submit"
            sx={{ textTransform: "none" }}
            onClick={handleButtonClick}
          >
            {t("AddPaymentMethod")}
          </Button>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        style={{
          width: "100%",
          textAlign: "center",
          justifyContent: "center",
          marginTop: 10,
        }}
      >
        {showIframe && paymentContext.url && (
          <Accordion
            style={{
              marginLeft: IsDesktop ? "25%" : "0%",
              width: IsDesktop ? "50%" : "100%",
            }}
            defaultExpanded
            id="sectionResNumber"
          >
            <h2>
              {updateCard?
              <AccordionSummary
                aria-controls="marketpayframe"
                id="addPayment"
                className={classes.heading}
              >
                {t("ReservationWizard.paymentPage.updateCard")}
              </AccordionSummary>:
              <AccordionSummary
                aria-controls="marketpayframe"
                id="addPayment"
                className={classes.heading}
              >
                {t("ReservationWizard.paymentPage.labelSectionAddPayment")}
              </AccordionSummary>}
            </h2>
            <AccordionDetails>
              <iframe
                id="marketpayframe"
                src={paymentContext.url}
                title="Test"
                width={"100%"}
                height={frameHeight}
                style={{ border: "0px" }}
                sandbox="allow-popups allow-scripts allow-same-origin allow-forms"
              ></iframe>
            </AccordionDetails>
          </Accordion>
        )}
      </Grid>
      <Grid item xs={12} style={{ textAlign: "center", width: "100%" }}>
        {showResult && paymentResult && (
          <div>
            <SavedCardResult
              data={paymentResult?.data}
              errors={errorMessage}
              success={true}
              deleteCard={handleDeleteSavedCardDialogOpen}
              updateCard={handleUpdateCard}
              isExpired={props.isExpired}
            />
          </div>
        )}
      </Grid>
    </Box>
  );
};
export default MyPaymentMethod;
